/*
 * This while fle is a bit of a dumping ground for miscellaneous
 * stuff that should be found a better home
 */

// todo: find a better place to  put this...
if (!Object.keys) {
  Object.keys = (function () {
    var hasOwnProperty = Object.prototype.hasOwnProperty,
      hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
      dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
      ],
      dontEnumsLength = dontEnums.length;

    return function (obj) {
      if (typeof obj !== 'object' && typeof obj !== 'function' || obj === null) throw new TypeError('Object.keys called on non-object');

      var result = [];

      for (var prop in obj) {
        if (hasOwnProperty.call(obj, prop)) result.push(prop);
      }

      if (hasDontEnumBug) {
        for (var i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) result.push(dontEnums[i]);
        }
      }
      return result;
    };
  })();
};

// and trim a string!!
if (typeof String.prototype.trim !== 'function') {
  String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g, '');
  };
}

// Extension methods for special string handling
String.prototype.urlEncode = function () {
  return this.replace(/&{1,}/g, "and")
    .replace(/[^a-z0-9]/gi, '-')
    .replace(/\-{2,}/g, "-");
};

String.prototype.removeSpaces = function () {
  return this.replace(/ /g, '');
};

String.prototype.toCamelCase = function () {
  var words = this.split(' ');
  words[0] = words[0].toLowerCase();

  // each word after the first is to be lowercase with an initial Capita;
  for (var i = 1; i < words.length; i++) {
    words[i] = words[i].toLowerCase();
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
  }

  return words.join('');
};

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (searchString, position) {
    var subjectString = this.toString();
    if (position === undefined || position > subjectString.length) {
      position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.lastIndexOf(searchString, position) === position;
  };
}

// Add global "services" (like breeze and Q) to the Ng injector
// Learn about Angular dependency injection in this video
// http://www.youtube.com/watch?feature=player_embedded&v=1CpiB3Wk25U#t=2253s
//EICDataStream3.value('breeze', window.breeze)
//.value('Q', window.Q);



//-------------------------------------------------------------------------
// Module Declarations
//-----------------------------------------------------------------------
angular.module('enums', [])
  .value("ENUMS",
    {
      PROJECT_WATCH_CREATE_REASONS: {
        SELECTED_PROJECTS_FROM_SEARCH: 1,
        DYNAMIC_FROM_SEARCH: 2,
        RECENTLY_ADDED_PROJECTS: 3,
        INDIVIDUAL_PROJECT: 4
      }
    }
  );



angular.module('$anchorScroll', []).value('$anchorScroll', angular.noop);


var uiAutocomplete = function () {
  return {
    require: '?ngModel',
    restrict: 'A',
    link: function (scope, element, attrs) {
      var getOptions = function () {
        return angular.extend({}, scope.$eval(attrs.uiAutocomplete));
      };
      var initAutocompleteWidget = function () {
        var opts = getOptions();
        element.autocomplete(opts);
        ;
        if (opts._renderItem) {
          element.data("uiAutocomplete")._renderItem = opts._renderItem;
        }
        element.keypress(function (e) {
          if (e.keyCode === 13) {
            element.autocomplete('close');
          }
        });


      };
      // Watch for changes to the directives options
      scope.$watch(getOptions, initAutocompleteWidget, true);
    }
  };

};
angular.module('ui.directives', [])
  .directive('uiAutocomplete', [uiAutocomplete]);




//------------------------------------------------------------------------
//  Truncate text
//------------------------------------------------------------------------
// add the filter to your application module
angular.module('truncate', ['filters']);

/**
 * Truncate Filter
 * @Param text
 * @Param length, default is 10
 * @Param end, default is "..."
 * @return string
 */
angular.module('filters', []).
  filter('truncate', function () {
    return function (text, length, end) {
      if (!text) return undefined; // text is undefined
      if (isNaN(length))
        length = 10;

      if (end === undefined)
        end = "...";

      if (text.length <= length || text.length - end.length <= length) {
        return text;
      }
      else {
        return String(text).substring(0, length - end.length) + end;
      }

    };
  });

/**
 * Usage
 *
 * var myText = "This is an example.";
 *
 * {{myText|Truncate}}
 * {{myText|Truncate:5}}
 * {{myText|Truncate:25:" ->"}}
 * Output
 * "This is..."
 * "Th..."
 * "This is an e ->"
 *
 */
//------------------------------------------------------------------------



//-------------------------------------------------------------------------
// https://gist.github.com/leehsueh/3956497
// <div jq-show-effect="whatever you use for ng-show" jq-options="{type:'fade', duration:200, delay:200, hideImmediately: true}">Content</div>
//-------------------------------------------------------------------------

var app = angular.module('jqShowEffect', []);
app.directive('jqShowEffect',
  [
    '$timeout',
    function($timeout) {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          // configure options
          var passedOptions = scope.$eval(attrs.jqOptions);

          // defaults
          var options = {
            type: 'fade', // or 'slide'
            duration: 200,
            delay: 0,
            hideImmediately: false, // if true, will hide without effects or duration
            callback: function() {
              if (!scope.$$phase) scope.$apply();
            }
          };
          $.extend(options, passedOptions);
          var type = options.type;
          var duration = options.duration;
          var callback = options.callback;
          var delay = options.delay;
          var hideImmediately = options.hideImmediately;

          // watch the trigger
          var jqElm = $(element);
          scope.$watch(attrs.jqShowEffect,
            function(value) {
              if (hideImmediately && !value) {
                jqElm.hide(0, callback);
              } else {
                $timeout(function() {
                    if (type === 'fade') {
                      value ? jqElm.fadeIn(duration, callback) : jqElm.fadeOut(duration, callback);
                    } else if (type === 'slide') {
                      value ? jqElm.slideDown(duration, callback) : jqElm.slideUp(duration, callback);
                    } else {
                      value ? jqElm.show(duration, callback) : jqElm.hide(duration, callback);
                    }
                  },
                  delay);
              }
            });
        }
      };
    }
  ]);



angular.module('EICDataStream3.projectDataServices', [])
  .factory('trackingStatusService', [
    function () {
      var trackingStatusService = {};

      trackingStatusService.selectedValues = [];
      trackingStatusService.listItems = [
        { text: "Active", value: 1, selected: true, visible: function () { return true; } },
        { text: "Future", value: 3, selected: true, visible: function () { return true; } },
        { text: "Archived", value: 4, selected: false, visible: function () { return true; } },
        { text: "Cancelled", value: 6, selected: false, visible: function () { return true; } }
      ];

      return trackingStatusService;
    }
  ]);
